import { createSelector } from "reselect";
import { AxiosError } from "axios";

import { IRootState } from "../reducers";
import { IBillingHistoryState } from "./types";
import { Invoice } from "../../types/common";

export const selectBillingHistoryState = (
  state: IRootState,
): IBillingHistoryState => {
  return state.billingHistory;
};

export const selectInvoices = createSelector(
  [selectBillingHistoryState],
  (billingHistoryState: IBillingHistoryState): Invoice[] => {
    const sortedInvoices = billingHistoryState?.data.sort((a, b) => {
      return Date.parse(b.created_at) - Date.parse(a.created_at);
    });

    // Return most recent 12 invoices from all providers.
    return sortedInvoices.slice(0, 12);
  },
);

// Subscription ids whose invoices failed to read; page must report them.
export const selectFailedInvoiceSubscriptionIds = createSelector(
  [selectBillingHistoryState],
  (billingHistoryState: IBillingHistoryState): string[] => {
    return billingHistoryState?.failedSubscriptionIds ?? [];
  },
);

export const selectInvoicesError = createSelector(
  [selectBillingHistoryState],
  (billingHistoryState: IBillingHistoryState): AxiosError | undefined => {
    return billingHistoryState?.error;
  },
);

export const selectIsFetchingInvoices = createSelector(
  [selectBillingHistoryState],
  (billingHistoryState: IBillingHistoryState): boolean => {
    return billingHistoryState?.isFetchingInvoices;
  },
);
